module.exports = __webpack_public_path__ + "static/media/jcb.59dbd543.png";